import DataTable from '@medeloop/medeloop-components-library/dist/components/DataTable';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { OrganizationDataSource } from 'src/types/organizations';

interface OrganizationDataSourcesTableProps {
  dataSources: OrganizationDataSource[];
}

export function OrganizationDataSourcesTable({ dataSources }: OrganizationDataSourcesTableProps) {
  const { t } = useTranslation();

  return (
    <DataTable className="px-6 py-4">
      <DataTable.Header>
        <DataTable.HeaderCell>{t('name_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell>{t('display_name_header')}</DataTable.HeaderCell>
        <DataTable.HeaderCell>{t('created_header')}</DataTable.HeaderCell>
      </DataTable.Header>

      <DataTable.Body className="h-96 overflow-auto">
        {dataSources.length > 0 ? (
          dataSources.map((dataSource: OrganizationDataSource) => (
            <DataTable.Row key={dataSource.dataSourceId}>
              <DataTable.RowCell>{dataSource.dataSourceName}</DataTable.RowCell>
              <DataTable.RowCell>{dataSource.dataSourceDisplayName}</DataTable.RowCell>
              <DataTable.RowCell>
                {dayjs(dataSource.createdAt).format('YYYY-MM-DD')}
              </DataTable.RowCell>
            </DataTable.Row>
          ))
        ) : (
          <div className="flex flex-grow text-white items-center justify-center p-4">
            {t('no_data_sources_created')}
          </div>
        )}
      </DataTable.Body>
    </DataTable>
  );
}
